import odata from "@/core/api/mixin/odata";
import { odataCall } from "@/core/api/mixin/odata";
import rest from "@/core/api/mixin/rest";
import { apiClient } from "@/core/api/httpClient";

export const search = {
  ...odata("api-calls"),
  ...rest("api-calls"),
};

export const dateGrouped = async (type, params) => {
  return odataCall(`api-calls-report/date-report/${type}`, params);
};

export const grouped = async (type, params) => {
  return odataCall(`api-calls-report/grouped/${type}`, params);
};

export const apiReqyest = {
  getApiCallReqyest(param) {
    return apiClient.get(`/api-call-requests/${param}`);
  },
};

export const clientSummary = async ($filter) => {
  const params = $filter ? { $filter } : {};
  return await apiClient.get(`api-calls-report/client-summary`, {
    params,
  });
};

export const productSummary = async ($filter) => {
  const params = $filter ? { $filter } : {};
  return await apiClient.get(`api-calls-report/product-summary`, {
    params,
  });
};

export const searchByType = async (type, searchValue) => odataCall(`api-calls/search/${type}`, {
  $filter: searchValue,
});
